module.exports = __webpack_public_path__ + "img/ef2a269a51ea0d271c779abfd450c3db.png";